// Military notification sound generator using Web Audio API
// Short, distinctive "tactical comm" beep - 2 rapid tones

let audioContext = null;
let audioContextError = null;

function getAudioContext() {
  if (!audioContext && !audioContextError) {
    try {
      audioContext = new (window.AudioContext || window.webkitAudioContext)();
    } catch (err) {
      audioContextError = err;
      console.warn('[Audio] Failed to initialize AudioContext:', err);
      return null;
    }
  }
  return audioContext || null;
}

export function playMilitaryNotifSound() {
  try {
    const ctx = getAudioContext();
    if (!ctx) {
      console.warn('[Audio] AudioContext not available — device audio may be blocked or unavailable');
      return;
    }
    if (ctx.state === 'suspended') {
      ctx.resume();
    }
    
    const now = ctx.currentTime;
    
    // First beep - sharp, short
    const osc1 = ctx.createOscillator();
    const gain1 = ctx.createGain();
    osc1.type = 'square';
    osc1.frequency.setValueAtTime(880, now); // A5 
    gain1.gain.setValueAtTime(0.08, now);
    gain1.gain.exponentialRampToValueAtTime(0.001, now + 0.08);
    osc1.connect(gain1);
    gain1.connect(ctx.destination);
    osc1.start(now);
    osc1.stop(now + 0.08);
    
    // Second beep - slightly higher, confirms
    const osc2 = ctx.createOscillator();
    const gain2 = ctx.createGain();
    osc2.type = 'square';
    osc2.frequency.setValueAtTime(1100, now + 0.1); // C#6
    gain2.gain.setValueAtTime(0.06, now + 0.1);
    gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.2);
    osc2.connect(gain2);
    gain2.connect(ctx.destination);
    osc2.start(now + 0.1);
    osc2.stop(now + 0.2);
    
  } catch (e) {
    // Audio not supported or blocked — silent fail
  }
}
